module.exports = "/images/arrow.svg";